import React from "react";

import { IConfig } from "@server/server";

/**
 * provides application configuration as a wrapper to components.
 * @example
 * <ConfigurationProvider>
 *     <MyComponent />
 * </ConfigurationProvider>
 * Then inside your component:
 * @example
 * import { Configuration } from "@advice/components/shared/Configuration";
 * export const MyComponent: React.FC = () => {
 *     const Configuration = useContext(Configuration);
 *     console.log("href", Configuration.href);
 * }
 */
const Configuration = React.createContext(({} as any) as IConfig);

const ConfigurationProvider: React.FC<IConfig> = props => {
    return <Configuration.Provider value={props}>{props.children}</Configuration.Provider>;
};

export { Configuration, ConfigurationProvider };
